import { useCallback, useEffect, useState } from 'react'

/**
 * Persistierter useState-Wrapper auf localStorage.
 * JSON-serialisiert. Bei Quota- oder Privacy-Mode-Fehlern silent fallback in den
 * In-Memory-State (kein Crash).
 *
 * Schluessel-Konvention: `mindkeep:<scope>`.
 */
export function useLocalStorage<T>(key: string, initial: T): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    if (typeof window === 'undefined') return initial
    try {
      const raw = window.localStorage.getItem(key)
      return raw !== null ? (JSON.parse(raw) as T) : initial
    } catch {
      return initial
    }
  })

  useEffect(() => {
    if (typeof window === 'undefined') return
    try {
      if (value === null) window.localStorage.removeItem(key)
      else window.localStorage.setItem(key, JSON.stringify(value))
    } catch {
      /* quota / privacy mode — silent */
    }
  }, [key, value])

  const setter = useCallback((next: T) => setValue(next), [])
  return [value, setter]
}
